
import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator';
import Loading from '@/components/loading/index.vue';
import { getCurrentMonth, getLastMonth } from '@/common/utils';
import publicUploadModal from '@/views/workbenches/subassembly/publicUploadModal.vue';
import moment from 'moment';
import { AuthEnum } from '@/services/permission.service';


@Component({
  components: {
    Loading,
    publicUploadModal,
  },
})
export default class QuickEntrance extends Vue {
  typeList: any = {
    icon_xianjinliu: 'workbenches.shouldEnrich',
    icon_hebingzhifu: 'workbenches.mergePayment',
    icon_jixiao: 'workbenches.operationalPerformance',
    icon_jiankangshuju: 'workbenches.promoteCollision',
    icon_kaidan: 'workbenches.promotionOfBilling',
    icon_rengongjixiao: 'workbenches.ministerialPerformance',
    icon_wanchenglv: 'workbenches.promotionCompletion',
    icon_increase: 'workbenches.growthData',
    icon_performance: 'workbenches.monthlyPerformance',
    icon_baobiao: 'workbenches.reportForms',
    icon_yungongjixiao: 'workbenches.operationalPerformanceLeader',
    promotion_completion_rate: 'workbenches.PromotionCompletionRate',
    analytics: 'workbenches.AdvertiserFollowUp',
    promote_daily_data: 'workbenches.PromoteDailyData',
    shop_inspection_data: 'workbenches.ShopInspectionData',
    participate_in_activities: 'workbenches.ParticipateInActivities',
    // 3.0新增
    CPSStandardData: 'workbenches.CPSInvestmentPromotion', // CPS标品招商数据
    PerformanceTargetConfiguration: 'workbenches.sevenTwo', // 绩效目标配置
    WriteOffGMVAmount: 'workbenches.WriteGMVAmount', // 核销GMV金额数据
    ListRechargeStores: 'workbenches.ListRechargeStores', // 推广通充值门店列表
    ConsumptionTargetManagement: 'workbenches.sevenFive', // 消耗额目标管理
    CPSStandardTarget: 'workbenches.sevenSix', // CPS标品目标数量配置
    ManuallyUploadPerformance: 'workbenches.sevenSeven', // 手动上传成绩得分
  };

  AuthEnum = AuthEnum;

  lading = false;

  @Prop({ type: String, default: 'assistantDirector' })
  type?: any;

  @Prop({ type: Array, default: [] })
  userModule?: any;

  @Ref('publicUploadModal')
  publicUploadModal!: publicUploadModal;

  @Watch('type')
  watchType() {
    this.lading = true;
  }

  moment = moment;

  uploadUrl: any = {
    dataType: false, // 是否需要传参
    data: {}, // 参数
    url: '', // 上传地址
    name: '', // 模版名称
    title: '', // 模版标题
    month: getCurrentMonth(), // 月份
  };

  closeLading() {
    this.lading = true;
  }
  // 页面跳转
  handleClick(name: string, type: string) {
    if (name === 'icon_kaidan' || name === 'icon_hebingzhifu' || name === 'icon_baobiao') {
      const query: any = {
        month: getCurrentMonth(),
        module: type,
      };
      this.$router.push({ name: this.typeList[name], query });
    } else if (name === 'icon_jixiao' || name === 'icon_jiankangshuju' || name === 'icon_rengongjixiao' || name === 'icon_yungongjixiao') {
      const query: any = {
        month: getLastMonth(),
        module: type,
      };
      this.$router.push({ name: this.typeList[name], query });
    } else if (name === 'icon_wanchenglv' || name === 'promotion_completion_rate' || name === 'WriteOffGMVAmount') {
      const query: any = {
        month: getCurrentMonth(),
        type: this.type,
        module: type,
      };
      this.$router.push({ name: this.typeList[name], query });
    } else if (name === 'ConsumptionTargetManagement') {
      this.$router.push({
        name: 'workbenches.TargetConsumptionManagement',
      });
    } else {
      this.$router.push({ name: this.typeList[name], query: { module: type } });
    }
  }
  // 弹窗
  modalClick(name: string, type: string) {
    this.uploadUrl.month = getCurrentMonth();
    if (name === 'PerformanceTargetConfiguration') {
      this.uploadUrl.title = '绩效目标配置';
      this.uploadUrl._url = '/wb/ad/upload_target';
      this.uploadUrl.url = `/wb/ad/upload_target?month=${this.uploadUrl.month}`;
      this.uploadUrl.name = '绩效目标配置';
      this.uploadUrl.dataType = false;
      this.uploadUrl.data = {
        module: type,
      };
    } else if (name === 'CPSStandardTarget') {
      this.uploadUrl.title = 'CPS标品目标数量配置';
      this.uploadUrl._url = '/ad/upload_target';
      this.uploadUrl.url = `/ad/upload_target?month=${this.uploadUrl.month}`;
      this.uploadUrl.name = 'CPS标品目标数量配置';
      this.uploadUrl.dataType = false;
      this.uploadUrl.data = {
        module: type,
      };
    }

    this.publicUploadModal.init(name, type);
  }

  changeUploaMonth(val: any) {
    const year = val._d.getFullYear(); // 获取当前年份，例如：2021
    let month: any = Number(val._d.getMonth()) + 1; // 获取当前月份，注意需要加1，例如：9
    if (month < 10) {
      month = `0${month}`;
    }
    this.uploadUrl.month = `${year}-${month}`;
    this.uploadUrl.url = `${this.uploadUrl._url}?month=${this.uploadUrl.month}`;
  }
}
